// extracted by mini-css-extract-plugin
export default {"defaultBorder":"styles_defaultBorder__WFuUT","containerUploadImages":"styles_containerUploadImages__yyH87","title":"styles_title__eB5HM"};